import './pdf-progress-bar.scss'

import { faCheck, faClipboard, faCube, faPenFancy, faSearch } from '@fortawesome/free-solid-svg-icons';
import Component from 'vue-class-component';

import { ReactiveVue } from '@skinsoft/reactive-vue';

import { PDF_STEP_COMPLETE_TOPIC } from '../../../busTopics';

@Component({
    template: require('./pdf-progress-bar.html')
})
export class PDFProgressBar extends ReactiveVue {

    // Icons
    private objectIcon = faCube;
    private generalOverviewIcon = faClipboard;
    private defectsIcon = faSearch;
    private observationsIcon = faClipboard;
    private contextIcon = faPenFancy;
    private successIcon = faCheck;

    private currentStep = 1;

    public mounted() {
        this.subscribeToBus(PDF_STEP_COMPLETE_TOPIC, (message) => {
            this.currentStep = message.payload.step;
        })
    }

    private getIconClassFromStep(index) {
        if (index === this.currentStep) {
            if (index === 5) {
                return 'current-complete-step-icon'
            } else {
                return 'current-step-icon'
            }
        } else if (index < this.currentStep) {
            return 'complete-step-icon'
        } else {
            return 'step-icon'
        }
    }

    private getLineClassFromStep(index) {
        if (index <= this.currentStep) {
            return 'complete-svg-line'
        } else {
            return 'svg-line'
        }
    }

    private isCurrentStep(index) {
        return index === this.currentStep;
    }

}